<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: '',
  },
})

const VUE_ASSETS_URL = process.env.VUE_APP_ASSETS_URL
</script>

<template>
  <!-- Usar v-show en lugar de v-if para evitar reflow del DOM -->
  <div
    v-show="props.isOpen"
    class="kiwish-loading-backdrop"
    role="status"
    aria-live="polite"
    :aria-busy="props.isOpen"
    :aria-label="props.message || 'Cargando...'"
  >
    <!-- Logo centrado como fondo -->
    <img
      :src="VUE_ASSETS_URL + 'logokw.png'"
      :srcset="VUE_ASSETS_URL + 'logokw.png 1x, ' + VUE_ASSETS_URL + 'logokw@2.png 2x'"
      alt="Kiwish"
      class="kiwish-loading-logo"
    />

    <!-- Caja del loader -->
    <div class="kiwish-loading-box">
      <img
        src="/assets/imgs/icons/load_kiwish.png"
        alt=""
        aria-hidden="true"
        class="kiwish-loading-img"
      />
      <p v-if="props.message" class="kiwish-loading-text" aria-live="assertive">
        {{ props.message }}
      </p>
    </div>
  </div>
</template>

<style>
/* Fondo que cubre toda la pantalla */
.kiwish-loading-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  background: #FF5287;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Logo centrado */
.kiwish-loading-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: auto;
  opacity: 0.15;
}

/* Caja del loader */
.kiwish-loading-box {
  background: #fff7e2;
  padding: 16px 22px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
  max-width: 70%;
  width: auto;
}

/* Imagen girando */
.kiwish-loading-img {
  width: 34px;
  height: 34px;
  -webkit-animation: kiwish-spin 0.9s linear infinite;
  animation: kiwish-spin 0.9s linear infinite;
}

/* Texto opcional debajo */
.kiwish-loading-text {
  margin-top: 10px;
  font-size: 0.9rem;
  color: #5A695B;
  text-align: center;
}

@-webkit-keyframes kiwish-spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes kiwish-spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>